import React, { forwardRef, HTMLAttributes, useEffect, useRef } from 'react';

interface TimeItemProps extends HTMLAttributes<HTMLButtonElement> {}

const TimeItem = forwardRef<HTMLButtonElement, TimeItemProps>((props, ref) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (ref) {
      if (typeof ref === 'function') {
        ref(buttonRef.current);
      } else {
        ref.current = buttonRef.current;
      }
    }
  }, [ref]);

  return (
    <button
      role="tab"
      ref={buttonRef}
      onKeyDown={e => {
        if (buttonRef.current) {
          if (e.key === 'ArrowUp') {
            const prev = buttonRef.current.previousSibling as HTMLButtonElement;

            if (prev) {
              prev.focus();
            }
          }

          if (e.key === 'ArrowDown') {
            const next = buttonRef.current.nextSibling as HTMLButtonElement;

            if (next) {
              next.focus();
            }
          }
        }
        props.onKeyDown?.(e);
      }}
      {...props}
    />
  );
});

export default TimeItem;
